import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { projectQueries } from '@/lib/queries/project';

import { NewProjectForm } from './-components/NewProjectForm';

export const Route = createFileRoute('/_root/new-project/')({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.newProject' }),
  }),
  loader: async ({ context: { queryClient } }) => {
    const { defaultProject } = await queryClient.ensureQueryData(
      projectQueries.default(),
    );

    if (defaultProject !== undefined) {
      throw redirect({ to: '/configuration' });
    }
  },
});

function RouteComponent() {
  useSuspenseQuery(projectQueries.default());

  return (
    <>
      <h1 className="text-3xl mb-4">
        <FormattedMessage id="newProject.title" />
      </h1>
      <NewProjectForm />
    </>
  );
}
